import i18n from "../i18n";

var selected_language = localStorage.getItem("language");
if (selected_language == '') {
    selected_language = 'en'
    i18n.locale = "en"
}
if (selected_language == "fa") {
    i18n.locale = "fa"
}
export default [
    {
        _name: 'CSidebarNav',
        redirect: '/dashboard/',
        _children: [
            {
                _name: 'CSidebarNavItem',
                name: i18n.t('dashboard'),
                to: '/dashboard',
                icon: 'cil-speedometer',
            },

            // **************************
            // {
            //     _name: 'CSidebarNavItem',
            //     name: "رزرو ها",
            //     to: '/dashboard/orders',
            //     icon: 'cil-list',
            // },
            // **************************
            // {
            //
            //     _name: 'CSidebarNavDropdown',
            //     name: 'بلاگ',
            //     route: '/dashboard/news',
            //     icon: 'cil-address-book',
            //
            //     items: [
            //         {
            //             name:"دسته بندی",
            //             to: '/dashboard/news/categories/0',
            //             role: 'blog_category'
            //
            //         },
            //         {
            //             name: "افزودن نوشته",
            //             to: '/dashboard/news/add-news',
            //             role: 'blog_post'
            //         },
            //         {
            //             name: 'لیست نوشته ها',
            //             to: '/dashboard/news/all-news',
            //             role: 'blog_post',
            //         },
            //
            //         {
            //             name: 'برچسب ها',
            //             to: '/dashboard/news/tags',
            //             role: 'blog_tags'
            //         },
            //         {
            //             name: "دیدگاه ها",
            //             to: '/dashboard/news/comments'
            //             , role: 'blog_comments',
            //         },
            //     ]
            // },

            //**************************8
            // {
            //     _name: 'CSidebarNavDropdown',
            //     name: "کاربران پنل",
            //     route: '/dashboard/users',
            //     icon: 'cil-user',
            //
            //     items: [
            //         //
            //         // {
            //         //     name: 'گروه های دسترسی',
            //         //     to: '/dashboard/users/permission-groups',
            //         //     role: 'permission_groups'
            //         // },
            //         {
            //             name: 'کاربران',
            //             to: '/dashboard/users/admins',
            //             role: 'admins'
            //         },
            //     ]
            // },
            //**************************8 //**************************8
            // {
            //     name: 'سفارشات',
            //
            //     _name: 'CSidebarNavDropdown',
            //     route: '/dashboard/orders',
            //     icon: 'cil-cart',
            //
            //     items: [
            //
            //         {
            //             name: 'کل سفارشات',
            //             to: '/dashboard/orders/list',
            //             role: 'order_list',
            //
            //         },
            //         {
            //             name: 'افزودن سفارش',
            //             to: '/dashboard/orders/add-order'
            //             , role: 'add_order'
            //
            //         },
            //         {
            //             name: 'مشتریان',
            //             to: '/dashboard/orders/customers'
            //             , role: 'add_order'
            //
            //         },
            //     ]
            // },
            //**************************8 //**************************8
            // {
            //     name: i18n.t('items'),
            //
            //     _name: 'CSidebarNavDropdown',
            //     route: '/dashboard/products',
            //     icon: 'cil-calculator',
            //
            //     items: [
            //         {
            //             name: i18n.t('add_item'),
            //             to: '/dashboard/products/create',
            //             role: 'add_product'
            //         }, {
            //             name: i18n.t('items_list'),
            //             to: '/dashboard/products/list',
            //             role: 'add_product'
            //         }, {
            //             name: i18n.t('categories'),
            //             to: '/dashboard/products/category/0',
            //             role: 'product_category'
            //         },
            //         // {
            //         //     name: "الگو مشخصات",
            //         //     to: '/dashboard/products/property-templates',
            //         //     role: 'template_property'
            //         // },
            //         // {
            //         //     name: "برچسب محصولات",
            //         //     to: '/dashboard/products/tags',
            //         //     role: 'product_tags'
            //         // },
            //         // {
            //         //     name: i18n.t('item_comments'),
            //         //     to: '/dashboard/products/comments',
            //         //     role: 'product_comments'
            //         // },
            //         {
            //             name: i18n.t('tables'),
            //             to: '/dashboard/products/tables',
            //             role: 'product_brands'
            //         },
            //         {
            //             name: i18n.t('labels'),
            //             to: '/dashboard/products/labels',
            //             role: 'product_labels'
            //         },
            //
            //
            //     ]
            // },

            //**************************8 //**************************8
            {
                _name: 'CSidebarNavItem',
                name: i18n.t('panel_users'),
                to: '/dashboard/users/admins',
                icon: 'cil-user',
                role: 'admins',
            },

            //**************************8 //**************************8
            {
                _name: 'CSidebarNavItem',
                name: i18n.t('lines'),
                to: '/dashboard/categories/list',
                icon: 'cil-list',
                role: 'admins',

            }, {
                _name: 'CSidebarNavItem',
                name: 'خدمات',
                to: '/dashboard/lines/list',
                icon: 'cil-list',
                role: 'admins',

            }, {
                _name: 'CSidebarNavItem',
                name: 'وقت های رزرو من',
                to: '/dashboard/lines/my-list',
                icon: 'cil-task',
            },
            {
                _name: 'CSidebarNavItem',
                name: "مشتریان من",
                to: '/dashboard/my-customers',
                icon: 'cil-people',
            },
            {
                _name: 'CSidebarNavDropdown',
                name: "مالی",
                to: '/dashboard/deposits',
                icon: 'cil-money',
                role: 'admins',
                items: [
                    {
                        name: 'تراکنش ها',
                        to: '/dashboard/deposits/transactions',
                        role: 'admins'
                    },
                    {
                        name: "تسویه ها",
                        to: '/dashboard/deposits/settlements',
                        role: 'admins'
                    },
                    {
                        name: "تنظیمات",
                        to: '/dashboard/deposits/deposits',
                        role: 'admins'
                    },
                ]
            },

            {
                _name: 'CSidebarNavItem',
                name: "نمونه کار ها",
                to: '/dashboard/portfolios',
                icon: 'cil-image',
                role: 'admins',

            },
            {
                _name: 'CSidebarNavItem',
                name: "جشنواره",
                to: '/dashboard/promotions/promotions',
                icon: 'cil-gift',
                role: 'admins',
            },
            {
                _name: 'CSidebarNavItem',
                name: i18n.t('support'),
                to: '/dashboard/messages/list',
                icon: 'cilEnvelopeClosed',

            },
            {
                _name: 'CSidebarNavItem',
                name: i18n.t('notification_center'),
                to: '/dashboard/notifications/list',
                icon: 'cilBell',

            },

            {
                _name: 'CSidebarNavItem',
                name: i18n.t('settings'),
                to: '/dashboard/settings/main-setting',
                icon: 'cil-settings',
                role: 'admins',
            },
            {
                _name: 'CSidebarNavItem',
                name: i18n.t('help'),
                to: '/dashboard/settings/help',
                role: 'basic_settings',
                icon: 'cil-info',

            },
//             {
//
//                 _name: 'CSidebarNavDropdown',
//                 name: i18n.t('settings'),
//                 route: '/dashboard/settings',
//                 icon: 'cil-settings',
// role: 'basic_settings',
//                 items: [
//                     // {
//                     //     name: 'روش های ارسال',
//                     //     to: '/dashboard/settings/shipping',
//                     //     role: 'shipping'
//                     // },
//                     // {
//                     //     name: "ریدایرکت",
//                     //     to: '/dashboard/settings/redirect',
//                     //     role: 'redirect'
//                     // },
//                     // {
//                     //     name: "وضعیت های سفارش",
//                     //     to: '/dashboard/settings/order_status',
//                     //     role: 'add_order_status'
//                     // },
//                     // {
//                     //     name: "کد های تخفیف",
//                     //     to: '/dashboard/settings/off_coupons',
//                     //     role: 'off_coupons'
//                     // },
//                     // {
//                     //     name: "درگاه های پرداخت",
//                     //     to: '/dashboard/settings/gateways',
//                     //     role: 'gateways'
//                     // },
//                     // {
//                     //     name: i18n.t('sliders'),
//                     //     to: '/dashboard/display/sliders',
//                     //     role: 'ui_slider'
//                     // },
//                     {
//                         name: i18n.t('settings'),
//                         to: '/dashboard/settings/main-setting',
//                         role: 'basic_settings'
//                     },
//                     {
//                         name: i18n.t('help'),
//                         to: '/dashboard/settings/help',
//                         role: 'basic_settings'
//                     },
//
//                 ]
//             },
//

            // {
            //
            //     _name: 'CSidebarNavItem',
            //     name: "گزارشات کالا",
            //     route: '/dashboard/reports',
            //     to: '/dashboard/reports/all',
            //     icon: 'cil-book',
            //     role: 'edit_settings',
            // },
            //**************************8


            //**************************8

            //**************************8 //**************************8 //**************************8 //**************************8
            //**************************8 //**************************8


        ]
    }
]
